
import React from "react";
import Header from "./Header/header";
import Main from "./Main/main";



function Pictures() {
  return (
    <div>
      <Header />
      <Main />
  
    </div>
  );
}

export default Pictures;
